import { ResourceAnalysis } from "../components/resource-analysis";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { FamilyMemberHistoryRowData } from "../tables/family-history";

export type FamilyHistorySidePanelContentProps = {
  data: FamilyMemberHistoryRowData;
};

export function FamilyHistorySidePanelContent({ data }: FamilyHistorySidePanelContentProps) {
  return (
    <SidePanelLayout title="Family Member History" subtitle={data.familyMember}>
      <ResourceAnalysis />

      <DocumentsSection resources={[data.originalData]} resourceType="FamilyMemberHistory" />
    </SidePanelLayout>
  );
}
